import { Component } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map'

@Component({
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
    private error: string = '';
    private flyers: any;
    private loading: boolean = true;
    public constructor(private http: Http, private router: Router) {
        let token = localStorage.getItem('amt_flyer_token');
        let headers = new Headers();
        headers.append('Authorization', token);

        this.http.get(environment.endpoint+'/load/all', {headers: headers})
            .map(res => res.json(), err => err.json())
            .subscribe(
                res => {
                    if(res.status === 'OK')
                        this.flyers = res.results;
                    else
                        this.error = res.results;
                    this.loading = false;
                },
                err => { this.loading = false; this.error = err; }
            );
    }

    public signOut(): void {
        localStorage.setItem('amt_flyer_token', null);
        localStorage.removeItem('amt_flyer_token');
        this.router.navigate(['/sign-in']);
    }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts